import { Component, OnInit, Input } from '@angular/core';
import { PropertyListingService } from '../../../../providers/property-listing.service';
import { LoaderService } from '../../../../providers/loader.service';
import { CommonService } from '../../../../providers/common.service';
import { ValidationService } from '../../../../providers/validation.service';
import { ActivatedRoute } from '@angular/router';
import { NewsTickerDetailsModel } from '../../../../models/NewsTickerDetailsModel';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService, private Loader: LoaderService, private commonService: CommonService, public Validation: ValidationService, protected activatedRoute: ActivatedRoute) { }

  @Input() tickerSymbol = null;
  statistics = {} as any;
  statisticsDetails = {} as any;
  showStatistics = false;
  newsDetail = {} as NewsTickerDetailsModel;
  ngOnInit() {
    this.Loader.display(true);
    this.loadData();
  }
  loadData() {
    if (this.tickerSymbol != null && this.tickerSymbol != '' && this.tickerSymbol != undefined) {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6104).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getStatistics();

        }
        else {
          this.statisticsDetails = JSON.parse(response.DataJson);
          this.statistics = this.statisticsDetails != null ? this.statisticsDetails?.quoteSummary?.result[0] : null;
          this.showStatistics = true;
          this.Loader.display(false);
        }
      });
    }
  }

  getStatistics() {
    this.propertyListing.GetStatitics(this.tickerSymbol).subscribe(response => {
      if (response != null) {
        this.statisticsDetails = response;
        this.statistics = this.statisticsDetails != null ? this.statisticsDetails?.quoteSummary?.result[0] : null;
        if (this.statistics != null) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6104;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
      this.showStatistics = true;
      this.Loader.display(false);
    });
  }

}
